import React, { Component } from 'react'
import { ReactComponent as QuestionIcon } from './question.svg'
import { ReactComponent as ArrowRight } from '../../../icons/arrow-right.svg'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../utils/classes'

export class Header extends Component {
  baseClass = extendParentClass.bind(this)('header')

  extend = extendBaseClass.bind(this)

  content = this.extend('content')

  extendContent = (childClass) => extend(this.content, childClass)

  render() {
    const questionsBtn = this.extendContent('questions-btn')
    return (
      <div className={this.baseClass}>
        <div className={this.content}>
          <QuestionIcon className={this.extendContent('icon')} />
          <h2 className={this.extendContent('title')}>
            Frequently Asked Questions
          </h2>
          <button className={questionsBtn}>
            More Questions{' '}
            <ArrowRight className={extend(questionsBtn, 'icon')} />
          </button>
        </div>
      </div>
    )
  }
}

export default Header
